import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToMinutes'
})
export class SecondsToMinutesPipe implements PipeTransform {
  transform(value: any): any {
    // pipe turns 124 into 2:04
    if (isNaN(value)) {
      // if what is passed is something like expired return the text
      return value;
    } else if (value === null) {
      // if null return empty string
      return '';
    } else if (value === 0) {
      return '00:00';
    }
    const mins = Math.floor(value / 60);
    return (
      mins.toString().padStart(2, '0') +
      ':' +
      (value - mins * 60).toString().padStart(2, '0')
    );
  }
}
